/* «Semana a semana» de Sideral · Línea de tiempo (ajuste «Animar al hacer scroll»): la línea se
   llena con el scroll, los pasos se encienden, la figura cambia de texto y el video (si hay) se
   adelanta o se atrasa siguiendo el scroll. Con prefers-reduced-motion todo queda encendido. */
;(function () {
  if (window.__sxLandingLinea) return
  window.__sxLandingLinea = true
  var quieto =
    window.matchMedia &&
    window.matchMedia('(prefers-reduced-motion: reduce)').matches

  function alVer(el, cb, margen) {
    if (!('IntersectionObserver' in window)) return cb(true)
    new IntersectionObserver(
      function (e) {
        cb(e[0].isIntersecting)
      },
      { rootMargin: margen || '200px' }
    ).observe(el)
  }

  // Bajar el video entero hace que adelantar y atrasar sea fluido; si falla, se usa la URL directa.
  function cargarVideo(video, listo) {
    var url = video.dataset.sxSrc
    if (!url || video.getAttribute('src')) return
    var poner = function (u) {
      video.src = u
      video.load()
    }
    video.addEventListener('loadedmetadata', listo)
    if (!window.fetch || !window.URL || quieto) return poner(url)
    fetch(url)
      .then(function (r) {
        if (!r.ok) throw new Error(String(r.status))
        return r.blob()
      })
      .then(function (b) {
        poner(URL.createObjectURL(b))
      })
      .catch(function () {
        poner(url)
      })
  }

  function linea(caja) {
    var pasos = [].slice.call(caja.querySelectorAll('[data-sx-linea-paso]'))
    if (!pasos.length || caja.__sxLinea) return
    caja.__sxLinea = true
    var pista = caja.querySelector('.sx-linea__pista')
    var relleno = caja.querySelector('[data-sx-linea-relleno]')
    var barra = caja.querySelector('[data-sx-linea-barra]')
    var cuando = caja.querySelector('[data-sx-linea-cuando]')
    var figura = caja.querySelector('[data-sx-linea-figura]')
    var video = caja.querySelector('video[data-sx-linea-video]')
    var tiempos = pasos.map(function (p) {
      return Number(p.dataset.segundo) || 0
    })
    var actual = -1
    var meta = 0
    var t = -1
    var activo = false
    var pendiente = false
    caja.classList.add('sx-linea--viva')

    function encender(k) {
      if (k === actual) return
      actual = k
      pasos.forEach(function (p, i) {
        p.classList.toggle('sx-linea__paso--on', i <= k)
      })
      var fig = pasos[k].querySelector('[data-sx-figura]')
      var cu = pasos[k].querySelector('[data-sx-cuando]')
      if (cuando && cu) cuando.textContent = cu.textContent
      if (figura && fig) figura.textContent = fig.textContent
      if (barra) barra.style.width = ((k + 1) * 100) / pasos.length + '%'
    }

    if (quieto) {
      encender(pasos.length - 1)
      if (relleno) relleno.style.height = 'calc(100% - 12px)'
      if (video)
        cargarVideo(video, function () {
          video.currentTime = tiempos[tiempos.length - 1]
        })
      return
    }

    // El video se acerca suave al segundo que pide el scroll (como en la referencia).
    function acercar() {
      t += (meta - t) * 0.25
      if (Math.abs(video.currentTime - t) > 0.04 && !video.seeking)
        video.currentTime = Math.min(t, video.duration - 0.05)
      if (activo && Math.abs(meta - t) > 0.02)
        window.requestAnimationFrame(acercar)
    }

    function medir() {
      pendiente = false
      var mitad = window.innerHeight * 0.5
      var ys = pasos.map(function (p) {
        return p.getBoundingClientRect().top
      })
      var k = 0
      ys.forEach(function (y, i) {
        if (y < mitad) k = i
      })
      encender(k)
      if (relleno && pista) {
        var r = pista.getBoundingClientRect()
        relleno.style.height =
          Math.max(0, Math.min(r.height - 12, mitad - r.top)) + 'px'
      }
      if (!video || !video.duration) return
      var n = ys.length - 1
      if (mitad <= ys[0]) meta = tiempos[0]
      else if (mitad >= ys[n]) meta = tiempos[n]
      else
        for (var i = 0; i < n; i++)
          if (mitad >= ys[i] && mitad < ys[i + 1]) {
            var f = (mitad - ys[i]) / (ys[i + 1] - ys[i] || 1)
            meta = tiempos[i] + (tiempos[i + 1] - tiempos[i]) * f
            break
          }
      if (t < 0) t = meta
      acercar()
    }

    function pedir() {
      if (!activo || pendiente) return
      pendiente = true
      window.requestAnimationFrame(medir)
    }

    if (video)
      alVer(
        caja,
        function (si) {
          if (si) cargarVideo(video, pedir)
        },
        '150%'
      )
    alVer(caja, function (si) {
      activo = si
      pedir()
    })
    window.addEventListener('scroll', pedir, { passive: true })
    window.addEventListener('resize', pedir)
    encender(0)
  }

  function iniciar(raiz) {
    raiz.querySelectorAll('[data-sx-linea]').forEach(linea)
  }
  if (document.readyState === 'loading')
    document.addEventListener('DOMContentLoaded', function () {
      iniciar(document)
    })
  else iniciar(document)
  document.addEventListener('shopify:section:load', function (e) {
    iniciar(e.target)
  })
})()
